// src/hooks/useChat.js

import { useState, useEffect, useRef } from 'react';
import { io } from 'socket.io-client';
import axios from 'axios';

// 💡 Replace with your actual backend URL
const BACKEND_URL = 'https://api.fitoja.in'; 

export const useChat = () => {
    const [isConnected, setIsConnected] = useState(false);
    const [messages, setMessages] = useState([]);
    const [roomId, setRoomId] = useState(null);
    const [conversationId, setConversationId] = useState(null);
    
    // Use ref to hold the socket instance
    const socketRef = useRef(null);

    // 1. Connection and Setup
    useEffect(() => {
        // Only connect if a roomId exists
        if (!roomId) return;

        // Initialize socket and connect
        socketRef.current = io(BACKEND_URL);

        socketRef.current.on('connect', () => {
            setIsConnected(true);
            console.log('Socket connected, joining room:', roomId);
            
            // 💡 CRITICAL: Join the specific chat room
            socketRef.current.emit('customer:join_room', roomId);
        });

        // 2. Message Receiving
        socketRef.current.on('receive_message', (message) => {
            console.log('Received message:', message);
            // Add the new message to the state
            setMessages((prevMessages) => [...prevMessages, message]);
        });
        
        socketRef.current.on('disconnect', () => {
            setIsConnected(false);
        });

        // Cleanup on unmount
        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
            }
        };
    }, [roomId]); // Re-run effect only when roomId changes

    // 3. Start Conversation REST API Call
    const startNewConversation = async (customerId = null) => {
        try {
            const response = await axios.post(`${BACKEND_URL}/api/chat/start`, { customerId });
            const { conversationId, roomId } = response.data;
            
            // Store the IDs and trigger the useEffect to establish socket connection
            setConversationId(conversationId);
            setRoomId(roomId); 
            
            // NOTE: You can also fetch past messages if you implement that in the backend
            // here, but for a new customer chat, history will be empty.

            return { success: true };
        } catch (error) {
            console.error("Error starting conversation:", error);
            return { success: false, error };
        }
    };
    
    // 4. Send Message Function
    const sendMessage = (text) => {
        if (socketRef.current && isConnected && roomId && text.trim()) {
            const messageData = {
                roomId: roomId,
                senderType: 'Customer', // IMPORTANT: Identifies the sender
                text: text,
            };
            
            // Optimistically add the message to the UI
            // setMessages((prevMessages) => [...prevMessages, messageData]);

            // Send to the server
            socketRef.current.emit('send_message', messageData);
        }
    };

    return {
        isConnected,
        messages,
        roomId,
        conversationId,
        startNewConversation,
        sendMessage,
        // You'll need a way to check if chat is active (roomId !== null)
        isChatActive: roomId !== null, 
    };
};